import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb20000a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"font-weight":"bold"}
}, "账号等级说明", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"font-weight":"bold"}
}, "商品列表", -1))
const _hoisted_5 = {
  class: "line",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_6 = { style: {"margin-top":"12px","text-align":"right"} }

import ScPage from '@/components/common/page/ScPage.vue';
import { onMounted, ref, shallowRef } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { request } from '@/util/request';
import { windows } from '@/components/common/window/Windows';
import Payment from '@/views/home/Payment.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {

const setting = ref();
onMounted(async () => {
  const res = await request('/management/setting/get', { key: 'app' });
  if (res) {
    setting.value = res.value;
  }
});

const products = ref();
onMounted(async () => {
  const res = await request('/management/product/list');
  if (res) {
    products.value = res.list;
  }
});

async function buy(product: { id: string; name: string }) {
  const res = await request('/management/product/buy', {
    id: product.id,
  });
  if (!res) {
    return;
  }
  windows.open({
    content: {
      type: 'component',
      component: shallowRef(Payment),
      props: {
        order: res.order,
        qrUrl: res.qrUrl,
      },
    },
    title: '扫码支付',
    width: 400,
    height: 500,
    mask: true,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(ScPage, { title: "套餐购买" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          innerHTML: setting.value?.levelDesc
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product, index) => {
            return (_openBlock(), _createBlock(_component_a_card, {
              size: "small",
              style: {"min-width":"200px","margin":"0 20px 20px 0"},
              title: product.name,
              key: index
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, "价格：" + _toDisplayString(product.price) + "元", 1),
                _createElementVNode("div", null, "充值天数：" + _toDisplayString(product.duration) + "天", 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(ScBtn, {
                    handler: () => buy(product),
                    size: "small",
                    type: "primary",
                    text: "立即购买"
                  }, null, 8, ["handler"])
                ])
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})